import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Cache from '@/helper/Cache.js';
import Account from '@/helper/AccountHelper.js';

/**
 * @method getStamp
 * @method getStampProfile
 * @method getPaycodeStamp
 */

export default {
	config: function() {
		return Vue.bzbsConfig;
	},
	token: function() {
		return Account.getCacheToken() ? Account.getCacheToken() : null
	},
	ewallet_token: function() {
		return Account.getCacheWalletToken() ? Account.getCacheWalletToken() : null
	},
	app_id: function() {
		if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')) != null) {
			if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId != undefined) {
				return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId;
			} else {
				return Account.getCacheCustom('app_id');
			}
		} else {
			return Account.getCacheCustom('app_id');
		}
	},
	agency_id: function() {
		return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).sponsorId;
	},
	getStamp: function() {
		var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/stamp';
		return BzbsApi.connectBzbsGet(strUrl, this.token(), null);
	},
	getStampProfile: function(stampId, cardId) {
		var strUrl =
			this.config().bzbEwalletUrl +
			'/stamp/' +
			stampId +
			'/profile?device_app_id=' +
			this.app_id() +
			'&cardId=' +
			cardId +
			'&agencyId=' +
			this.agency_id();
		return BzbsApi.connectBzbsGet(strUrl, this.ewallet_token(), null);
	},
	getPaycodeStamp: function(cardId) {
		var strUrl =
			this.config().bzbEwalletUrl +
			'/wallet/paycode?device_app_id=' +
			this.app_id() +
			'&agencyId=' +
			this.agency_id() +
			'&mode=stamp' +
			'&cardid=' +
			cardId;
		return BzbsApi.connectBzbsGet(strUrl, this.ewallet_token(), null);
	}
};
